import React from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { get, set, isEmpty } from "lodash";

import LenderContactInformation from "./lenderContactInformation";
import {
  StyledGridContainer,
  StyledFormikInputTypeAhead
} from "./quoteDetails.styles";

// there's only 1 lender for quotes
const lenderFieldPath = "details.loanProvider[0].loanCompanyBridge";

const handleLenderCompanyChange = formik => {
  formik.setFieldValue(`${lenderFieldPath}.companyContactId`, null);
  formik.setFieldValue(`${lenderFieldPath}.lenderTypeId`, null);
};

const getLenderContacts = values => {
  const lenderCompanyId = get(values, `${lenderFieldPath}.companyId`);
  if (!lenderCompanyId) {
    return [];
  }
  const lenders = get(values, "ancillary.lenders", []);
  const ourLender = lenders.filter(lender => lender.id === lenderCompanyId);
  if (!ourLender) {
    return [];
  }

  return get(ourLender, "[0].contacts", []);
};

const getLenderContact = values => {
  if (isEmpty(values) || !values.details) {
    return null;
  }

  const contacts = getLenderContacts(values);
  const lenderCompanyContactId = get(
    values,
    `${lenderFieldPath}.companyContactId`
  );
  if (isEmpty(contacts) || !lenderCompanyContactId) {
    return null;
  }
  const ourContact = contacts.filter(
    contact => contact.id === lenderCompanyContactId
  );

  return get(ourContact, "[0]", null);
};

const LenderInformation = ({ formik, onOpenRequestContactModal }) => {
  const { values } = formik;
  const lenderContact = getLenderContact(values) || {};
  const lenders = values && get(values, "ancillary.lenders", []);
  const lenderTypes = values && get(values, "ancillary.lenderTypes", []);

  return (
    <>
      <Grid item xs={12}>
        <StyledFormikInputTypeAhead
          id="lenderCompanyId"
          name={`${lenderFieldPath}.companyId`}
          label="Lender *"
          options={lenders}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={() => handleLenderCompanyChange(formik)}
          className="input"
          variant={"filled"}
        />
      </Grid>
      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="lenderTypeId"
          name={`${lenderFieldPath}.lenderTypeId`}
          label="Lender Type"
          options={lenderTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="lenderCompanyContactId"
          name={`${lenderFieldPath}.companyContactId`}
          label="Lender Contact"
          options={getLenderContacts(values)}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <LenderContactInformation
        lenderContact={lenderContact}
        handleOpenRequestContactModal={onOpenRequestContactModal}
      />
    </>
  );
};
export default compose(connect)(LenderInformation);
